import BankAccountsTable from "./BankAccountsTable"

export default BankAccountsTable
